import { Get, Post, postJson } from './httpServer';
import qs from 'qs';

export const server = {
  // 首页-用户信息
  getUser() {
    return Post(`/metering/navigationPage/queryPersonally`)
  },

  // 首页-企业公告
  getDynamicNoticeList(body) {
    return Post(`/metering/navigationPage/queryEnterpriseBulletinDynamic`, qs.stringify(body))
  },
  getNoticeList(body) {
    return Post(`/metering/navigationPage/queryEnterpriseBulletin`, qs.stringify(body))
  },

  // 首页-系统消息
  getSystemMessage(body) {
    return Post(`/metering/navigationPage/querySystemMessage`, qs.stringify(body))
  },

  // 首页-常用操作
  getCommonMenu() {
    return Post(`/metering/navigationPage/queryAllComOpera`)
  },

  // 首页-常用查看
  getCommonSee() {
    return Post(`/metering/navigationPage/queryAllComFun`)
  },

  // 首页-常用产品
  getProAppList() {
    return Post(`/metering/navigationPage/queryAllComPro`)
  },

  // 首页-常用工具
  getToolAppList() {
    return Post(`/metering/navigationPage/queryAllComTool`)
  },

  // 首页-企业中心下拉导航
  getEnterpriseMenu() {
    return Post(`/metering/navigationPage/queryAllComFun`)
  },

  // 首页-个人指数-考勤
  getAttendance() {
    return Post(`/metering/navigationPage/queryUserAttendance`)
  },

  // 首页-个人指数-个人收入
  getIncome() {
    return Post(`/metering/navigationPage/queryUserIncome`)
  },

  // 首页-查询当前常用操作、查看
  getCurrentApp() {
    return Post(`/metering/navigationPage/queryUserCommonFunction`)
  },

  // 保存常用操作
  getSaveOption(body) {
    return Post(`/metering/navigationPage/addUserCommonOperations`, qs.stringify(body))
  },

  // 保存常用查看
  getSaveSee(body) {
    return Post(`/metering/navigationPage/addUserCommonView`, qs.stringify(body))
  },

  // 首页-个人指数-排行榜
  getUserSort(url) {
    return Post(url)
  },

  // 首页-个人指数-经办款项
  getUserCollection() {
    return Post(`/metering/navigationPage/queryUserCollection`)
  },

  // 首页-运行指数-报告状态分布图
  getBusiness(body) {
    return Post(`/metering/navigationPage/queryBusinessStatusMap`, qs.stringify(body))
  },

  // 首页-财务指数-入账金额分布图
  getAccounting() {
    return Post(`/metering/navigationPage/queryAmountChart`)
  },

  // 首页-运行指数-排行榜
  getRunSort() {
    return Post(`/metering/navigationOperation/queryOperationIndexRank`)
  },
  // 首页-运行指数-打卡工时排行榜
  getCarding() {
    return Post(`/metering/navigationOperation/queryClockHourRank`)
  },

  // 首页-运行指数-考勤
  getWork() {
    return Post(`/metering/navigationPage/getClockStatusDistribution`)
  },

  // 首页-财务指数-收支余额对比图
  getReceipts() {
    return Post(`/metering/navigationPage/queryComparisonChart`)
  },

  // 首页-导航菜单点击跳转
  getMenuLinks(body) {
    return Post(`/metering/role/queryCurrentSonMenus`, qs.stringify(body))
  },

  // 首页-考勤日历
  getCalendars(body) {
    return Post(`/metering/navigationPage/queryUserMonthAttendance`, qs.stringify(body))
  },
  // 首页-初始化系统消息
  getInitMessage() {
    return Post(`/metering/MSGModuleCenterController/queryUserSystemMessage`)
  },
  // 首页-清空初始化系统消息
  getCloseMessage() {
    return Post(`/metering/MSGModuleCenterController/clearUserUnReadNum`)
  },

  // 企业中心-企业管理
  getEnterprise() {
    return Post(`/metering/registerer/lookEnterpriseInfo`)
  },
  // 企业中心-企业管理
  editSmsState(body) {
    return Get(`/metering//customerService/updEnterpriseShortMessageControl?msgAuth=${body}`)
  },

  // 企业中心-添加企业信息
  getAddEditEnterprise(body) {
    return Post(`/metering/customerService/addEnterpriseInfo`, qs.stringify(body))
  },

  // 企业中心-编辑修改企业信息
  getEditEnterprise(body) {
    return Post(`/metering/customerService/addEnterpriseInfo`, qs.stringify(body))
  },

  // 项目中心-我的项目列表
  getProjectList(body) {
    return Post('/metering/nProject/queryProejctListInfo', qs.stringify(body))
  },
  // 项目中心-项目人员
  getPersonnel() {
    return Get('/metering/nProject/queryProjectEmp')
  },
  // 项目中心-招标类别、招标方式
  getBusiDicItem(body) {
    return Get(`metering/busiDic/queryBusiDicItemSelectList?dicTypeCodes=${body}`)
  },
  // 项目中心-部门
  getBelongOrg() {
    return Get('/metering/nProject/queryProjectOrg')
  },

  // 项目中心-工作组备案
  getICP(body) {
    return Post(`/metering/nProject/queryWorkingGroupInfo`, qs.stringify(body))
  },
  // 导出报表
  getOutExecl(body) {
    return Post(`/metering/nProject/exportProejctDataInfoExcel`, qs.stringify(body))
  },

  // 项目详情
  getProjectDetails(body) {
    return Post(`/metering/nProject/queryProjectbyId`, qs.stringify(body))
  },
  // 项目详情-搁置
  getSuspended(body) {
    return Post(`/metering/nProject/updProjectShelveState`, qs.stringify(body))
  },
  // 项目详情-完成
  getDone(body) {
    return Post(`/metering/nProject/completeProjectOperation`, qs.stringify(body))
  },

  // 项目详情-轮播图提交
  addCarousel(body) {
    return Post(`/metering/nProject/saveProejctByImgData`, qs.stringify(body))
  },

  // 查询轮播图
  getCarousel(id) {
    return Get(`/metering/nProject/queryProejctByImgData?projectid=${id}`)
  },

  // 项目详情-任务列表数据
  getTaskList(body) {
    return Post(`/metering/projectTask/queryTaskBasicInfoList`, qs.stringify(body))
  },
  // 项目详情-任务-评分
  submitScore(body) {
    return Post(`/metering/projectTask/updProejctTaskScore`, qs.stringify(body))
  },
  // 项目详情-删除任务
  deleteTaskItem(body, state) {
    return Get(`/metering/projectTask/delTaskBasicInfo?taskid=${body}&state=${state}`)
  },
  // 项目详情-删除任务
  addSubTask(body) {
    return Post(`/metering/projectTask/saveSunTaskBasicInfo`, qs.stringify(body))
  },
  // 项目详情-删除任务
  seeSubTask(body) {
    return Get(`/metering/projectTask/querySunTaskBasicInfo?taskid=${body}`)
  },
  // 项目详情-任务-负责人接口
  getMaster(body) {
    return Get(`/metering/projectTask/queryProejctUserListInfo?projectid=${body}`)
  },
  // 项目详情-任务-打印
  Print(body) {
    return Get(`/metering/projectTask/queryTaskBasicInfoPrinting?projectid=${body}`)
  },
  // 项目详情-审批列表数据
  getApprovalList(body) {
    return Post(`/metering/projectApproval/queryProjectApprovalBasicInfo`, qs.stringify(body))
  },
  // 项目详情-文件列表
  getFileList(body) {
    return Post(`/metering/projectFile/queryProjectFileListInfo`, qs.stringify(body))
  },
  // 项目详情-文件目录树
  getFileTree(body) {
    return Post(`/metering/fileTemplate/queryProjectFileTemplateTree`, qs.stringify(body))
  },
  // 项目详情-文件目录树-删除
  deleteFileTree(body) {
    return Post(`/metering/fileTemplate/delFileTemplateTreeNode`, qs.stringify(body))
  },
  // 项目详情-文件目录树-添加
  addFileTree(body) {
    return Post(`/metering/fileTemplate/addFileTemplateTreeNode`, qs.stringify(body))
  },
  // 项目详情-文件目录树-编辑
  editFileTree(body) {
    return Post(`/metering/fileTemplate/addFileTemplateTreeNode`, qs.stringify(body))
  },
  // 项目详情-文件目录树点击查询列表
  getFileTreeList(body) {
    return Post(`metering/project/queryProjectAllFiles`, qs.stringify(body))
  },
  // 项目详情-文件-确定私密
  submitPrivate(body) {
    return Post(`/metering/file/addFileShareUser`, qs.stringify(body))
  },
  // 项目详情-文件-编辑私密人员
  getPrivate(body) {
    return Post(`/metering/file/queryFileShareUserById`, qs.stringify(body))
  },
  // 项目详情-文件-删除私密
  deletePrivate(body) {
    return Post(`/metering/file/delFileShareInfo`, qs.stringify(body))
  },
  // 项目详情-文件-共享人员
  getFileUserList(body) {
    return Post(`/metering/file/queryFileShareUserById`, qs.stringify(body))
  },
  // 文件批量下载
  downloadFileList(body) {
    return Post(`/metering/fileCommon/queryFileBatchDown`, qs.stringify(body))
  },
  // 项目详情-文件列表
  deleteFileItem(body) {
    return Get(`/metering/projectFile/delProjectFileById?fileid=${body}`)
  },

  // 项目详情-人员列表
  getUserList(body) {
    return Post(`/metering/projectUser/queryProjectUserBasicInfo`, qs.stringify(body))
  },
  // 项目详情-人员列表
  deleteUser(body) {
    return Get(`/metering/projectUser/delProjectUser?attenId=${body}`)
  },
  // 项目详情-人员列表-成员新增、邀请关注
  addUser(body) {
    return Post(`/metering/projectUser/sendBatchProjectUserInfo`, qs.stringify(body))
  },
  // 我的动态-动态回复
  queryReplyList(body) {
    return Post(`/metering/projectNewDynamic/queryReplyList`, qs.stringify(body))
  },
  // 项目详情-动态列表
  getLiveList(body) {
    return Post(`/metering/projectNewDynamic/queryProjectDynamicList`, qs.stringify(body))
  },
  //刷新动态回复
  getDynamicReplyBySayId(param) {
    return Post(`/metering/projectNewDynamic/queryDynamicReplyList`, qs.stringify(param))
  },
  // 项目详情-动态发布
  addLiveItem(body) {
    return Post(`/metering/projectNewDynamic/addDynamicInfo`, qs.stringify(body))
  },
  // 项目详情-删除动态
  deleteLiveItem(body) {
    return Post(`/metering/projectNewDynamic/delDynamicInfo`, qs.stringify(body))
  },
  // 项目详情-点赞、取消点赞
  addPraise(body) {
    return Post(`/metering/projectNewDynamic/addDynamicLikeNum`, qs.stringify(body))
  },
  // 项目详情-阶段列表
  // getPhaseList(body){
  //   return Get(`/metering/nProject/queryProjectStageInitDataInfo?projectid=${body}`)
  // },

  // 首页-未读消息数量
  getInfo() {
    return Post(`/metering/navigationPage/queryNotReadMsg`)
  },

  // 个人中心-查询信息
  getIndividualInfo() {
    return Post(`/metering/personalCenter/queryPersonalInformation`)
  },
  // 上传文件
  getUpload(body) {
    return Post(`/metering/upload/uploadfile`, qs.stringify(body))
  },
  // 个人中心-保存信息
  getSaveIndividual(body) {
    return Post(`/metering/personalCenter/updatePersonInfomation`, qs.stringify(body))
  },

  // 个人中心-所有专业
  getBusiDic(body) {
    return Post(`/metering/busiDic/getBusiDicItemMultiSelectTree`, qs.stringify(body))
  },

  // 安全设置-修改登录密码
  UpdateLoginPassword(body) {
    return Post(`/metering/securitySettingsController/updateLoginPassword`, qs.stringify(body))
  },
  // 安全设置-修改文件密码
  UpdateFilePassword(body) {
    return Post(`/metering/securitySettingsController/updateFilePassword`, qs.stringify(body))
  },
  // 安全设置-修改手机号
  UpdatePhone(body) {
    return Post(`/metering/securitySettingsController/updateUserPhone`, qs.stringify(body))
  },
  // 文件下载
  FileDownd(id) {
    return Get(`/metering/down/fileDownLoadNew?fileid=${id}`)
  },
  // 加密文件下载
  FilePassDownd(fileid, filepass) {
    return Get(`/metering/down/downloadFileByPawAndId?fileid=${fileid}&filepass=${filepass}`)
  },

  // 批量下载
  batchDowndFile(body) {
    return Post(`/metering/fileCommon/queryFilebulkdownload`, qs.stringify(body))
  },

  // 项目中心-列表-归档列表
  getArchiveList({ projectid }) {
    return Get(`/metering/nProject/queryProjectByFileAll?projectid=${projectid}`)
  },

  // 项目中心-列表-归档文件树
  getArchiveFileTree() {
    return Get(`/metering/nProject/queryProjectFileTree`)
  },
  // 项目中心-列表-文件归档操作
  getArchiveFileOption(body) {
    return Post(`/metering/nProject/addFilingProjectDocuments`, qs.stringify(body))
  },
  // 项目中心-列表-文件归档操作
  fileUpload(body) {
    return Post(`/metering/projectFile/addProjectBatchFile`, qs.stringify(body))
  },
  // 项目中心-列表-取消归档操作
  getCancelArchive(body) {
    return Post(`/metering/nProject/updCancellationProjectFiles`, qs.stringify(body))
  },
  // 项目中心-列表-发起归档审批
  getApproval(body) {
    return Post(`/metering/documentApprove/addDocumentApprove`, qs.stringify(body))
  },
  // 项目中心-删除列表项目
  getDeleteProject(body) {
    return Post(`/metering/nProject/delProjectOperation`, qs.stringify(body))
  },
  // 项目中心-置顶操作
  getIsTop(body) {
    return Post(`/metering/nProject/projectRoofPlacement`, qs.stringify(body))
  },
  // 项目中心-招标代理列表
  getTenderList(body) {
    return Post(`/metering/projectTender/queryProjectTenderListInfo`, qs.stringify(body))
  },

  // 创建项目-人员tree树
  getUserTree() {
    return Get(`/metering/nProject/queryEmpMechanismTree`)
  },

  // 添加项目成员列表
  getAddUserList() {
    return Get(`/metering/nProject/queryProjectMemberTask`)
  },
  // 添加项目成员-点击添加，获得带有任务数的tree数据
  getAddUserTree() {
    return Get(`/metering/nProject/queryEmpMechanismTree`)
  },

  // 所属合同
  getContractList(body) {
    return Post(`/metering/nProject/queryProjectContactRecord`, qs.stringify(body))
  },
  // 委托单位
  getUnitsList(body) {
    return Post(`/metering/nProject/queryProjectPrincipalUnitRecord`, qs.stringify(body))
  },
  // 服务类型、所属专业接口
  getServerTypeList() {
    return Get(`/metering/nProject/queryProjectDictionaryRecord`)
  },
  // 编号类型
  getCodeTypeList() {
    return Get(`/metering/codeTree/queryALLSonCodeNumNode?reportNumberType=2`)
  },
  // 编号类型
  getProjectCode(codeType, reportNumberType, id) {
    return Get(`/metering/code/queryCodeNum?codeType=${codeType}&reportNumberType=${reportNumberType}&id=${id}`)
  },
  // 项目状态，业务取得方式，计算规则
  getSelectMap() {
    return Get(`/metering/busiDic/queryProjectBusinessList`)
  },
  // 阶段列表数据
  getPhaseList(body) {
    return Post(`/metering/phases/queryProjectPhases`, qs.stringify(body))
  },
  // 阶段列表数据
  editPhaseState(body) {
    return Post(`/metering/phases/updateProjectStage`, qs.stringify(body))
  },
  // 阶段列表-查看文件
  getPhaseFileList(body) {
    return Post(`/metering/file/queryDetailProjectFiles`, qs.stringify(body))
  },
  // 阶段列表-文件上传
  getPhaseFileUpload(body) {
    return Post(`/metering/phases/addPhaseFilesNew`, qs.stringify(body))
  },
  // 阶段列表-投标点击事件
  getAssociated(body) {
    return Post(`/metering/phases/queryPhaseRelatedBusiness`, qs.stringify(body))
  },

  // 集控中心数据
  getEchartsData() {
    return Post(`/metering/CentralizedControlCenter/queryCenterData`)
  },

  // 创建项目-自定义标签
  getDiyTag() {
    return Post(`/metering/property/getPropertyRender`, qs.stringify({ 'busiBelong': 'project' }))
  },

  // 获取省地质
  getProvinceData() {
    return Get(`../../NT/static/staticData.json`)
  },

  // 创建项目，第一步 - 基本信息
  createProjectOne(body) {
    return new Promise((resolve, rej) => {
      resolve(Post(`/metering/nProject/saveProejctByIdBasicInfo`, qs.stringify(body)))
    })
  },
  // 创建项目，第一步 - 更多信息
  createProjectMoreInfo(body) {
    return new Promise((resolve, rej) => {
      resolve(Post(`/metering/nProject/updProejctByIdBasicInfo`, qs.stringify(body)))
    })
  },
  // 创建项目，第一步 - 文件
  createProjectFile(body) {
    return new Promise((resolve, rej) => {
      resolve(Post(`/metering/nProject/saveProejctByFilsInfo`, qs.stringify(body)))
    })
  },

  // 回显，第一步 - 基本信息
  editProjectOne(body) {
    return Post(`/metering/nProject/queryProejctByIdBasicInfo`, qs.stringify(body))
  },

  // 回显，第一步 - 基本信息
  editProjectMoreInfo(body) {
    return Post(`/metering/nProject/queryProejctByIdBasicEssInfo`, qs.stringify(body))
  },
  // 回显，第一步 - 文件
  editProjectFile(body) {
    return Post(`/metering/nProject/queryProejctByFileInfo`, qs.stringify(body))
  },

  // 回显 第二步 - 分配任务
  queryTaskUser(id) {
    return Get(`/metering/nProject/queryEmpMechanismTree?projectid=${id}`)
  },

  // 任务数点击事件
  getUserTask(id) {
    return Get(`/metering/nProject/queryProjectMemberTaskDetailed?userid=${id}`)
  },

  // 任务分类
  getTaskType(body) {
    return Post(`/metering/busiDic/queryBusiDicItemSelectList`, qs.stringify(body))
  },

  // 任务分配数据查询
  queryTaskData(body) {
    return Post(`/metering/nProject/queryProejctByTaskData`, qs.stringify(body))
  },

  // 任务分配新增
  addTaskList(body) {
    return Post(`/metering/nProject/saveProejctByTaskData`, qs.stringify(body))
  },

  // 阶段模板列表
  getPhaseTemplateList(body) {
    return Post(`/metering/phaseTemplate/queryPhaseTemplate`, qs.stringify(body))
  },

  // 选择模板后查询table数据
  getSelectTemplate(body) {
    return Post(`/metering/phaseTemplate/queryPhaseTemplateByIdForProject`, qs.stringify(body))
  },

  // 阶段模板回显数据
  getPhaseTableData(body) {
    return Post(`/metering/project/editProjectPhase`, qs.stringify(body))
  },

  // 修改项目阶段
  addPhaseData(body) {
    return Post(`/metering/project/dealProjectPhase`, qs.stringify(body))
  },

  // 初始化项目经理，关注者，项目成员
  projectInitUser() {
    return Get(`/metering/nProject/queryProjectTemplByEmp`)
  },

  // 项目详情-报告列表数据
  getReportTable(body) {
    return Post(`/metering/presentation/queryPresentation`, qs.stringify(body))
  },

  // 合同列表
  getContractListData(body) {
    return Post(`/metering/projectContract/queryProjectidByContract`, qs.stringify(body))
  },

  // 绑定合同列表
  getBindListData(page, search) {
    return Get(`/metering/projectContract/queryContractListData?page=${page}&pageCount=20&search=${search}`)
  },

  // 绑定合同确定事件
  bindSubmit(body) {
    return Post(`/metering/projectContract/updProjectBindContract`, qs.stringify(body))
  },

  // 用章列表
  getOfficialTable(body) {
    return Post(`/metering/projectSeal/querySealListInfo`, qs.stringify(body))
  },
  // 归档列表
  getArchiveTable(body) {
    return Post(`/metering/projectFile/queryProjectByArchive`, qs.stringify(body))
  },

  // 财务列表
  getFinancialTable(body) {
    return Post(`/metering/finance/queryFinanceDataList`, qs.stringify(body))
  },

  // 文件类型
  getFileType(body) {
    return Post(`/metering/fileTemplate/queryFileTemplateList`, qs.stringify(body))
  },

  // 项目动态
  getProjectDynamic(page) {
    var param = {
      page: page,
      pageCount: 5
    }
    // return Get(`/metering/projectDynamic/queryProjectDynamic?page=${page}&pageCount=5`)
    return Post(`/metering/projectNewDynamic/queryDynamicList`, qs.stringify(param))
  },

  //我的审批
  getApprovalTable(body) {
    return Post(`/metering/approval/queryApprovalList`, qs.stringify(body))
  },

  //我的审批
  operationApproval(body) {
    return Post(`/metering/approval/operationApprovalData`, qs.stringify(body))
  },

  // 首页-是否关注了公众号
  queryHavingNotAttentWecharUser() {
    return Post(`/metering/wecharMessage/queryHavingNotAttentWecharUser`)
  },
  // 首页-鱼骨图操作权限
  queryUserOpreationAuth() {
    return Post(`/metering/navigationPage/queryUserOpreationAuth`)
  },
  // 用户活跃数据
  queryUserActivityData(body) {
    return Post(`/metering/operation/queryUserActivityData`, qs.stringify(body), { timeout: 60 * 1000 })
  },
  // 所属上级项目
  getParentProjectList(body) {
    return Post(`/metering/project/queryEnterpriseAllprojects`, qs.stringify(body))
  },
  // 子项目列表
  getProjectListData(body) {
    return Post(`/metering/project/querySonProjectByProjectId`, qs.stringify(body))
  },
  // 绑定合同确定事件
  bindSonProjectSubmit(body) {
    return Post(`/metering/project/updProjectBindSon`, qs.stringify(body))
  },
  // 查询文件夹下QQ文档
  queryQQDocumentListByFolder(body) {
    return Post(`/metering/QQDocument/queryQQDocumentListByFolder`, qs.stringify(body))
  },
  // 查询企业项目名称集合
  queryProjectTitleList(body) {
    return Post(`/metering/projectType/queryProjectTitleListByType`, qs.stringify(body))
  },
  // 申请加入项目
  addProjectMemberApprove(body) {
    return Post(`/metering/project/addProjectMemberApprove`, qs.stringify(body))
  },
  // 项目中心-直接归档项目
  updateProjectState(body){
    return Post(`/metering/nProject/updateProjectState`,qs.stringify(body))
  },

  //查询项目人员角色
  queryProjectRole(body) {
    return Post(`/metering/nProject/queryProjectRole`, qs.stringify(body))
  },
  queryCurrentLoginUserRole() {
    return Post(`/metering/nProject/queryCurrentLoginUserRole`)
  },
  queryRoleById(body) {
    return Post(`/metering/role/queryRoleById`, qs.stringify(body))
  },
  // 产品中心-维护项目列表
  getProductList(body) {
    return Post('/metering/product/queryProductList', qs.stringify(body))
  },
  queryProductListByEffective(body) {
    return Post('/metering/product/queryProductListByEffective', qs.stringify(body))
  },
  // 产品中心-维护产品列表-产品详情
  getProduct(body) {
    return Post(`/metering/product/queryProduct`, qs.stringify(body))
  },
  addProducts(body) {
    return Post(`/metering/product/addProduct`, qs.stringify(body))
  },
  updateProducts(body) {
    return Post(`/metering/product/updateProduct`, qs.stringify(body))
  },
  delProducts(body) {
    return Post(`/metering/product/delProduct`, qs.stringify(body))
  },
  // 产品中心-项目案例列表
  getProductCaseList(body) {
    return Post('/metering/productCase/queryProducCaseList', qs.stringify(body))
  },
  queryProducCaseListByEffective(body) {
    return Post('/metering/productCase/queryProducCaseListByEffective', qs.stringify(body))
  },
  getProductCaseListTop3(body) {
    return Post('/metering/productCase/queryProducCaseListTop3', qs.stringify(body))
  },
  // 产品中心-维护产品列表-产品详情
  getProductsCase(body) {
    return Post(`/metering/productCase/queryProducCase`, qs.stringify(body))
  },
  addProductsCase(body) {
    return Post(`/metering/productCase/addProductCase`, qs.stringify(body))
  },
  updateProductsCase(body) {
    return Post(`/metering/productCase/updateProductCase`, qs.stringify(body))
  },
  delProductsCase(body) {
    return Post(`/metering/productCase/delProductCase`, qs.stringify(body))
  },
  // 产品中心-项目案例列表
  getProductCoList(body) {
    return Post('/metering/productCo/queryProducCoList', qs.stringify(body))
  },
  queryProducCoListByEffective(body) {
    return Post('/metering/productCo/queryProducCoListByEffective', qs.stringify(body))
  },
  // 产品中心-维护产品列表-产品详情
  getProductsCo(body) {
    return Post(`/metering/productCo/queryProducCo`, qs.stringify(body))
  },
  addProductsCo(body) {
    return Post(`/metering/productCo/addProductCo`, qs.stringify(body))
  },
  updateProductsCo(body) {
    return Post(`/metering/productCo/updateProductCo`, qs.stringify(body))
  },
  delProductsCo(body) {
    return Post(`/metering/productCo/delProductCo`, qs.stringify(body))
  },
  // 产品中心-图片列表
  getProductImgList(body) {
    return Post('/metering/productImg/queryProductImgList', qs.stringify(body))
  },
  queryProducImgListByEffective(body) {
    return Post('/metering/productImg/queryProducImgListByEffective', qs.stringify(body))
  },
  // 产品中心-图片详情
  getProductsImg(body) {
    return Post(`/metering/productImg/queryProductImg`, qs.stringify(body))
  },
  addProductsImg(body) {
    return Post(`/metering/productImg/addProductImg`, qs.stringify(body))
  },
  updateProductsImg(body) {
    return Post(`/metering/productImg/updateProductImg`, qs.stringify(body))
  },
  delProductsImg(body) {
    return Post(`/metering/productImg/delProductImg`, qs.stringify(body))
  },



  addCommonTool(body) {
    return Post(`/metering/commonTools/addCommonTool`, qs.stringify(body))
  },
  updateCommonTool(body) {
    return Post(`/metering/commonTools/updateCommonTool`, qs.stringify(body))
  },
  delCommonTool(body) {
    return Post(`/metering/commonTools/delCommonTool`, qs.stringify(body))
  },
  queryCommonToolList(body) {
    return Post(`/metering/commonTools/queryCommonToolList`, qs.stringify(body))
  },
  queryCommonTool(body) {
    return Post(`/metering/commonTools/queryCommonTool`, qs.stringify(body))
  },
  //用户等级
  getUserLevel() {
    return Post(`/metering/navigationPage/queryUserLevel`)
  },

  // 用户等级维护
  getUserLevelList(body) {
    return Post('/metering/userLevels/queryUserLevelList', qs.stringify(body))
  },
  getUserLevelDetail(body) {
    return Post(`/metering/userLevels/queryUserLevel`, qs.stringify(body))
  },
  addUserLevel(body) {
    return Post(`/metering/userLevels/addUserLevel`, qs.stringify(body))
  },
  updateUserLevel(body) {
    return Post(`/metering/userLevels/updateUserLevel`, qs.stringify(body))
  },
  deleteUserLevel(body) {
    return Post(`/metering/userLevels/delUserLevel`, qs.stringify(body))
  },

  getShareFilesList(body) {
    return Post(`/metering/QQDocument/queryQQDocumentFolderFilter`, qs.stringify(body))
  },
  createQQFile(body) {
    return Post(`/metering/QQDocument/createFile`, qs.stringify(body))
  },
  //查询首页全过程登陆地址
  getTianZhuRedictPage(body) {
    return Post(`/metering/tianZhu/getRedictPage`, qs.stringify(body))
  },
  //查询首页工具跳转链接
  getHanghangRedictPage(body) {
    return Post(`/metering/hanghang/getRedictPage`, qs.stringify(body))
  },
  // 获取天筑云xml文件类型
  getTianZhuXmlType() {
    return Get('/metering/tianZhu/getTianZhuXmlType')
  },

  //添加项目XML文件
  addProjectFile(body) {
    return Post(`/metering/file/addZbkXmlFile`, qs.stringify(body))
  },
  //获取项目XML文件列表
  queryZbkXmlFiles(body) {
    return Post(`metering/file/queryZbkXmlFiles`, qs.stringify(body))
  },
  //解析xml文件
  parseProjectXml(body) {
    return Post(`/metering/tianZhu/parseProjectXml`, qs.stringify(body))
  },
  //项目详情-删除xml文件
  deleteProjectXml(body) {
    return Get(`/metering/file/deleteProjectXml?fileid=${body}`)
  },
    //优路教育跳转
    getRedictPage(body) {
      return Post(`/metering/youlu/getRedictPage`, qs.stringify(body))
    },
  //查询首页全过程登陆地址
  getOthorProductRedictPage(body) {
    return Post(`/metering/othorProduct/getRedictPage`, qs.stringify(body))
  },
}



// WEBPACK FOOTER //
// ./src/utils/api.js